/**
 * Approval Center API — 人在回路审批中心（Mock 版）
 *
 * 4 种审批类型:
 *   content_review    → 素材审核（蓝）
 *   budget            → 预算审批（橙）
 *   influencer_email  → 达人建联（紫）
 *   strategy          → 策略确认（绿）
 *
 * 4 种状态:
 *   pending    — 待处理
 *   approved   — 已通过
 *   rejected   — 已驳回
 *   cancelled  — 已撤销
 */

const mockApprovals = [
  {
    id: 1,
    taskTitle: 'Q4美国市场广告素材',
    approvalType: 'content_review',
    agentName: 'Creative Agent',
    step: '素材合规审查',
    submitter: 'Creative Agent',
    submitTime: '2026-08-06 14:32',
    status: 'pending',
    priority: 'high',
    description: 'Q4 美国市场推广所需的视频广告素材，包含3支15秒短视频和6张静态图，需经合规审查后投放。',
    attachments: ['video_ad_01.mp4', 'static_01.jpg'],
  },
  {
    id: 2,
    taskTitle: '黑五促销预算申请',
    approvalType: 'budget',
    agentName: 'Marketing Agent',
    step: '预算审批',
    submitter: 'Marketing Agent',
    submitTime: '2026-08-06 11:15',
    status: 'pending',
    priority: 'high',
    description: '黑五促销活动期间社交媒体广告投放预算，总额 $50,000，覆盖 Meta、TikTok、Google 三个平台。',
    attachments: ['budget_plan.xlsx'],
  },
  {
    id: 3,
    taskTitle: '达人建联 — Sarah Johnson',
    approvalType: 'influencer_email',
    agentName: 'Outreach Agent',
    step: '邮件内容审核',
    submitter: 'Outreach Agent',
    submitTime: '2026-08-06 09:48',
    status: 'pending',
    priority: 'medium',
    description: '与 Instagram 达人 @sarahjohnson_style (120万粉丝) 的合作建联邮件，提案为Q4新品推广合作。',
    attachments: ['email_draft.txt'],
  },
  {
    id: 4,
    taskTitle: 'Q4社交媒体策略确认',
    approvalType: 'strategy',
    agentName: 'Strategy Agent',
    step: '策略评审',
    submitter: 'Strategy Agent',
    submitTime: '2026-08-05 17:20',
    status: 'pending',
    priority: 'medium',
    description: 'Q4 社交媒体内容策略方案，包括内容日历、平台分配、KPI 目标等。',
    attachments: ['q4_strategy.pdf'],
  },
  {
    id: 5,
    taskTitle: 'TikTok挑战赛素材',
    approvalType: 'content_review',
    agentName: 'Creative Agent',
    step: '素材合规审查',
    submitter: 'Creative Agent',
    submitTime: '2026-08-05 15:00',
    status: 'approved',
    priority: 'low',
    description: 'TikTok 挑战赛的宣传素材，已通过合规审查。',
    attachments: ['challenge_video.mp4'],
  },
  {
    id: 6,
    taskTitle: 'KOL合作预算追加',
    approvalType: 'budget',
    agentName: 'Marketing Agent',
    step: '预算审批',
    submitter: 'Marketing Agent',
    submitTime: '2026-08-05 10:30',
    status: 'approved',
    priority: 'medium',
    description: '原定 KOLO 合作预算 ¥200,000 追加至 ¥350,000，用于扩大合作范围。',
    attachments: ['budget_addition.xlsx'],
  },
  {
    id: 7,
    taskTitle: '达人建联 — Mike Chen',
    approvalType: 'influencer_email',
    agentName: 'Outreach Agent',
    step: '邮件内容审核',
    submitter: 'Outreach Agent',
    submitTime: '2026-08-04 16:45',
    status: 'rejected',
    priority: 'low',
    description: '与 YouTube 达人 @miketech (80万粉丝) 的合作提案，邮件内容需修改。',
    rejectReason: '邮件中产品卖点描述不够突出，建议重写第二段价值主张。',
    attachments: ['email_draft.txt'],
  },
  {
    id: 8,
    taskTitle: '品牌新年活动策略',
    approvalType: 'strategy',
    agentName: 'Strategy Agent',
    step: '策略评审',
    submitter: 'Strategy Agent',
    submitTime: '2026-08-04 14:00',
    status: 'rejected',
    priority: 'medium',
    description: '2027年新年品牌活动策略，目标提升品牌知名度 30%。',
    rejectReason: '用户画像分析不够充分，缺少竞品对标数据。',
    attachments: ['new_year_strategy.pdf'],
  },
  {
    id: 9,
    taskTitle: '欧洲市场广告素材V2',
    approvalType: 'content_review',
    agentName: 'Creative Agent',
    step: '素材合规审查',
    submitter: 'Creative Agent',
    submitTime: '2026-08-03 09:20',
    status: 'approved',
    priority: 'high',
    description: '欧洲市场广告素材第二版，已根据GDPR要求调整。',
    attachments: ['eu_ad_v2.mp4'],
  },
  {
    id: 10,
    taskTitle: 'PR危机公关邮件',
    approvalType: 'influencer_email',
    agentName: 'Outreach Agent',
    step: '邮件内容审核',
    submitter: 'Outreach Agent',
    submitTime: '2026-08-02 18:00',
    status: 'cancelled',
    priority: 'high',
    description: '针对产品质量投诉的危机公关回复邮件草稿。',
    attachments: ['crisis_email.txt'],
  },
];

// 模拟网络延迟
const delay = (ms = 300) => new Promise((r) => setTimeout(r, ms));

/**
 * 获取待我审批的列表
 */
export const listPending = async () => {
  await delay();
  return mockApprovals.filter((a) => a.status === 'pending');
};

/**
 * 获取全部审批列表
 */
export const listAll = async () => {
  await delay();
  return [...mockApprovals];
};

/**
 * 获取我发起的审批列表
 */
export const listSubmitted = async () => {
  await delay();
  // 模拟当前用户发起的流程（这里返回部分数据作为演示）
  return mockApprovals.filter((a) => ['Creative Agent', 'Marketing Agent'].includes(a.submitter));
};

/**
 * 通过审批
 * @param {number} id 审批ID
 * @param {string} comment 审批意见
 */
export const approve = async (id, comment = '') => {
  await delay(200);
  const item = mockApprovals.find((a) => a.id === id);
  if (item) {
    item.status = 'approved';
    item.approveComment = comment;
    item.approveTime = new Date().toLocaleString('zh-CN', { hour12: false }).replace(/\//g, '-');
  }
  return { success: true, id };
};

/**
 * 驳回审批
 * @param {number} id 审批ID
 * @param {string} reason 驳回原因（必填）
 */
export const reject = async (id, reason) => {
  await delay(200);
  if (!reason || !reason.trim()) {
    return Promise.reject(new Error('驳回原因不能为空'));
  }
  const item = mockApprovals.find((a) => a.id === id);
  if (item) {
    item.status = 'rejected';
    item.rejectReason = reason;
    item.rejectTime = new Date().toLocaleString('zh-CN', { hour12: false }).replace(/\//g, '-');
  }
  return { success: true, id };
};

/**
 * 获取待审批数量（用于 Badge）
 */
export const getPendingCount = async () => {
  await delay(100);
  return mockApprovals.filter((a) => a.status === 'pending').length;
};

export default {
  listPending,
  listAll,
  listSubmitted,
  approve,
  reject,
  getPendingCount,
};
